import type { BlockComponentStateId, BlockComponentType } from '../../types/block';
import type { SlotType } from '../../types/slot';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- Content is empty for now
export type DictationContent = {};

// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- Appearance is empty for now
export type DictationAppearance = {};

export type DictationSlots = {
  /**
   *  Body block to displayed inside dictation block
   */
  body?: SlotType;
};

export type DictationComponentType = BlockComponentType<
  'Dictation',
  DictationContent,
  DictationAppearance,
  DictationSlots
>;

export type DictationBlockStateType = Pick<
  DictationComponentType,
  'content' | 'componentType' | 'appearance'
> & { value?: string; isListening?: boolean } & BlockComponentStateId;

export enum DictationMethods {
  StartDictation = 'startDictation',
  StopDictation = 'stopDictation',
}

export type DictationBlockRef = {
  startDictation?: () => void;
  stopDictation?: () => void;
};
